import "moment/locale/ru";

import Timeline, {
  TimelineMarkers,
  TimelineHeaders,
  TodayMarker,
  CursorMarker,
  SidebarHeader,
  DateHeader,
} from "../../../../ui/CalendarTimeline";
// import Timeline, {
//   TimelineMarkers,
//   TimelineHeaders,
//   TodayMarker,
//   CursorMarker,
//   SidebarHeader,
//   DateHeader,
// } from "react-calendar-timeline";
import { Spring, animated } from "react-spring";
import "../../../../ui/CalendarTimeline/index.css";
import { useAppStore } from "../../../../stores/RootStore";
import { LifeData } from "../../../../types/formDataTypes";
import { DateTime } from "luxon";
import { useState } from "react";
import { t } from "i18next";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../../../ui/DropdownMenu/DropdownMenu";
import { Button } from "../../../../ui/Button";
import { TbArrowLeft, TbArrowRight } from "react-icons/tb";
import { Input } from "../../../../ui/Input/Input";
import RoleRequire from "../../../../helpers/auth/RoleRequire";
import MaintenancesFilters, { MaintenancesCategoriesType, MaintenancesFilterType } from "../MaintenancesFilters";
import { ScrollArea } from "../../../../ui/ScrollArea/ScrollArea";
import { rgbColor } from "../../../../enums/colors";
import { groupBy } from "../../../../helpers/utils";

const AnimatedTimeline = animated(
  ({ animatedVisibleTimeStart, animatedVisibleTimeEnd, visibleTimeStart, visibleTimeEnd, ...props }) => (
    <Timeline
      className="flex flex-col w-full h-full overflow-hidden mb-20"
      visibleTimeStart={animatedVisibleTimeStart}
      visibleTimeEnd={animatedVisibleTimeEnd}
      {...props}
    />
  )
);

let keys = {
  groupIdKey: "id",
  groupTitleKey: "title",
  groupRightTitleKey: "rightTitle",
  itemIdKey: "id",
  itemTitleKey: "title",
  itemDivTitleKey: "title",
  itemGroupKey: "group",
  itemTimeStartKey: "start",
  itemTimeEndKey: "end",
  groupLabelKey: "title",
};

export default function RepairTimeline({ data }: { data: LifeData[] }) {
  const { equipments } = useAppStore();
  const [visibleTime, setVisibleTime] = useState({
    start: DateTime.local().startOf("day").toMillis(),
    end: DateTime.local().startOf("day").plus({ days: 1 }).toMillis(),
  });
  const [period, setPeriod] = useState("day");
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState<MaintenancesFilterType>({
    producers: [],
    equipment_type: [],
    maintenance_type: [],
  });
  const categories: MaintenancesCategoriesType = {
    unique_equipment_type_name: [],
    unique_producer_name: [],
    unique_maintenance_type: [],
  };

  //Создание массивов с уникальными названиями для категорий фильтра
  if (data) {
    for (let i = 0; i < data.length; i++) {
      const elem = data[i];
      if (!categories.unique_equipment_type_name.includes(getEquipmentTypeById(elem.equipment_item_id)!))
        categories.unique_equipment_type_name.push(getEquipmentTypeById(elem.equipment_item_id)!);
      if (!categories.unique_producer_name.includes(getEquipmentProducerById(elem.equipment_item_id)!))
        categories.unique_producer_name.push(getEquipmentProducerById(elem.equipment_item_id)!);
    }
  }

  // Получение типа оборудования по его ID
  function getEquipmentTypeById(id: Number) {
    return equipments?.find((eq) => eq.id == String(id))?.attributes.equipment_type_name;
  }

  // Получение производителя по его ID
  function getEquipmentProducerById(id: Number) {
    return equipments?.find((eq) => eq.id == String(id))?.attributes.producer_name;
  }

  const handleSearch = (event: any) => {
    setSearch(event.target.value);
  };

  let full_data = data;

  // Фильтрация через поиск
  full_data = data.filter(
    (item) =>
      item.equipment_name.toLowerCase().includes(search.toLowerCase()) ||
      item.equipment_inventory_number!.toLowerCase().includes(search.toLowerCase())
  );

  //Фильтрация данных через категории
  full_data = data.filter(
    (item) =>
      (filter.producers.length > 0
        ? filter.producers.includes(getEquipmentProducerById(item.equipment_item_id)!)
        : true) &&
      (filter.equipment_type.length > 0
        ? filter.equipment_type.includes(getEquipmentTypeById(item.equipment_item_id)!)
        : true) &&
      (filter.maintenance_type.length > 0 ? filter.maintenance_type.includes(item.type) : true)
  );

  // Фильтрация групп через поиск
  const filteredSearchEquipments = equipments?.filter(
    (item) =>
      item.attributes.name.toLowerCase().includes(search.toLowerCase()) ||
      item.attributes.inventory_number.toLowerCase().includes(search.toLowerCase())
  );

  //Фильтрация групп через категории
  const filteredEquipments = filteredSearchEquipments?.filter(
    (item) =>
      (filter.producers.length > 0 ? filter.producers.includes(getEquipmentProducerById(Number(item.id))!) : true) &&
      (filter.equipment_type.length > 0 ? filter.equipment_type.includes(getEquipmentTypeById(Number(item.id))!) : true)
  );

  let groups: any[] = [];
  filteredEquipments &&
    filteredEquipments.map((e) => {
      groups.push({
        id: `e_${e.id}`,
        title: `${e.attributes.inventory_number}, ${e.attributes.name} `,
        rightTitle: `${e.attributes.inventory_number}, ${e.attributes.name} `,
      });
      groups.push({
        id: `s_${e.id}`,
        title: `${t("service")}`,
        rightTitle: `${t("service")}`,
      });
    });

  let items: any[] = [];

  full_data.map((i, index) => {
    items.push({
      id: items.length + 1,
      group: i.group === "lifecycle" ? `e_${i.equipment_item_id}` : `s_${i.equipment_item_id}`,
      canMove: false,
      dragging: false,
      type: i.type,
      title: <div className="flex flex-col w-full h-full">{renderItem(i.type)}</div>,
      start: i.start.valueOf(),
      end: i.end.valueOf(),
      className: `z-[9] ${i.start.weekday === 6 || i.start.weekday === 0 ? "item-weekend" : ""}`,
      itemProps: {
        "data-tip": "",
      },
    });
  });

  // Фильтрация оборудования, которое сейчас находится в ремонте
  const groupedRepairList = groupBy(items, (obj) => obj.group);
  const repairList = groupedRepairList
    .map((eq) => {
      const lastItem = eq[1].reduce((prev: any, current: any) => {
        return prev.end > current.end ? prev : current;
      });
      if (lastItem.type === "repair") return lastItem.group.slice(2);
    })
    .filter((obj) => obj !== undefined);

  groups = groups.filter((group) => repairList.includes(group.id.slice(2)));

  function renderItem(type: string) {
    switch (type) {
      case "works":
        return <div style={{ background: rgbColor.worked, width: "100%", height: `100%` }}></div>;
      case "broken":
        return <div style={{ background: rgbColor.broken, width: "100%", height: `100%` }}></div>;
      case "repair":
        return <div style={{ background: rgbColor.repair, width: "100%", height: `100%` }}></div>;
      case "service":
        return <div style={{ background: rgbColor.service, width: "100%", height: `100%` }}></div>;
      case "maintenance":
        return <div style={{ background: rgbColor.worked, width: "100%", height: `100%` }}></div>;
      default:
        return <div></div>;
    }
  }

  items = items.sort((a, b) => b - a);

  // const handleCanvasClick = (groupId: any, time: any) => {
  //   console.log("Canvas clicked", groupId, time);
  // };

  // const  handleCanvasDoubleClick = (groupId: any, time: any) => {
  //   console.log("Canvas double clicked", groupId, time);
  // };

  // const  handleCanvasContextMenu = (group: any, time: any) => {
  //   console.log("Canvas context menu", group, time);
  // };

  // const  handleItemClick = (itemId: string, _: any, time: any) => {
  //   console.log("Clicked: " + itemId, time);
  // };

  // const  handleItemSelect = (itemId: string, _: any, time: any) => {
  //   console.log("Selected: " + itemId,time);
  // };

  // const  handleItemDoubleClick = (itemId: string, _: any, time: any) => {
  //   console.log("Double Click: " + itemId, time);
  // };

  // const  handleItemContextMenu = (itemId: string, _: any, time: any) => {
  //   console.log("Context Menu: " + itemId, time);
  // };

  const handleTimeChange = (visibleTimeStart: number, visibleTimeEnd: number, updateScrollCanvas: any) => {
    setVisibleTime({ start: visibleTimeStart, end: visibleTimeEnd });
    let seconds = visibleTimeEnd - visibleTimeStart;
    if (seconds > 2678401000) {
      return setPeriod("year");
    } else if (seconds > 86401000) {
      return setPeriod("month");
    } else if (seconds > 3601000) {
      return setPeriod("day");
    } else {
      return setPeriod("hour");
    }
  };

  const onPrevClick = () => {
    const zoom = visibleTime.end - visibleTime.start;
    setVisibleTime({ start: visibleTime.start - zoom, end: visibleTime.end - zoom });
  };

  const onNextClick = () => {
    const zoom = visibleTime.end - visibleTime.start;
    setVisibleTime({ start: visibleTime.start + zoom, end: visibleTime.end + zoom });
  };

  function handleChangePeriod(unit: string) {
    setPeriod(unit);
    let currentYear = DateTime.fromMillis(visibleTime.start).year === DateTime.local().year;
    let start = DateTime.fromMillis(visibleTime.start);
    let end = DateTime.fromMillis(visibleTime.end);
    switch (unit) {
      case "year":
        setVisibleTime({
          start: start.startOf("year").toMillis(),
          end: end.startOf("year").plus({ years: 1 }).toMillis(),
        });
        break;
      case "month":
        setVisibleTime({
          start: (currentYear ? DateTime.local() : start).startOf("month").toMillis(),
          end: (currentYear ? DateTime.local() : end).startOf("month").plus({ months: 1 }).toMillis(),
        });
        break;
      case "day":
        setVisibleTime({
          start: (currentYear ? DateTime.local() : start).startOf("day").toMillis(),
          end: (currentYear ? DateTime.local() : end).startOf("day").plus({ days: 1 }).toMillis(),
        });
        break;
      case "hour":
        setVisibleTime({
          start: (currentYear ? DateTime.local() : start).startOf("hour").toMillis(),
          end: (currentYear ? DateTime.local() : end).startOf("hour").plus({ hours: 1 }).toMillis(),
        });
        break;
      default:
        setVisibleTime({
          start: DateTime.local().startOf("day").toMillis(),
          end: DateTime.local().startOf("day").plus({ days: 1 }).toMillis(),
        });
        break;
    }
  }

  return (
    <div className="w-full flex flex-col h-full px-6 text-sm">
      <div className="flex-none flex flex-col h-24 w-full">
        <div className="flex flex-row w-full h-14 items-center justify-between">
          <Input
            className="h-8"
            placeholder={t("equipment_search")}
            onChange={handleSearch}
            value={search}
            autoComplete="off"
            width="100%"
          />
        </div>
        <div className="flex items-center mb-2 justify-between w-full">
          <MaintenancesFilters filterState={[filter, setFilter]} categories={categories} />
          <div className="gap-2 flex items-center">
            <Button variant={"outline"} size={"xs"} onClick={onPrevClick}>
              <TbArrowLeft />
            </Button>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant={"outline"} size={"xs"} className="min-w-[120px] max-w-[120px] justify-start">
                  {t(period)}
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="start" className="min-w-[120px]">
                <DropdownMenuLabel>{t("periods")}</DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuRadioGroup value={period} onValueChange={(value) => handleChangePeriod(value)}>
                  {["year", "month", "day", "hour"].map((p) => (
                    <DropdownMenuRadioItem key={p} value={p}>
                      {t(p)}
                    </DropdownMenuRadioItem>
                  ))}
                </DropdownMenuRadioGroup>
              </DropdownMenuContent>
            </DropdownMenu>
            <Button variant={"outline"} size={"xs"} onClick={onNextClick}>
              <TbArrowRight />
            </Button>
          </div>
        </div>
      </div>
      <Spring
        to={{
          animatedVisibleTimeStart: visibleTime.start,
          animatedVisibleTimeEnd: visibleTime.end,
        }}
      >
        {(value: any) => (
          <AnimatedTimeline
            groups={groups}
            items={items}
            keys={keys}
            sidebarWidth={240}
            // sidebarContent={<div>{t('equipment')}</div>}
            canMove={false}
            canResize={false}
            canResizeLeft={false}
            canResizeRight={false}
            dragging={false}
            canSelect
            itemsSorted
            itemTouchSendsClick={false}
            stackItems
            itemHeightRatio={0.75}
            // onCanvasClick={handleCanvasClick}
            // onCanvasDoubleClick={handleCanvasDoubleClick}
            // onCanvasContextMenu={handleCanvasContextMenu}
            // onItemClick={handleItemClick}
            // onItemSelect={handleItemSelect}
            // onItemContextMenu={handleItemContextMenu}
            // onItemMove={handleItemMove}
            // onItemResize={handleItemResize}
            // onItemDoubleClick={handleItemDoubleClick}
            buffer={1}
            onTimeChange={handleTimeChange}
            {...value}
            // moveResizeValidator={moveResizeValidator}
          >
            <TimelineHeaders>
              <SidebarHeader>
                {({ getRootProps }) => {
                  return (
                    <div {...getRootProps()} className="flex px-2 items-end leading-8">
                      {t("equipment")}
                    </div>
                  );
                }}
              </SidebarHeader>
              <DateHeader unit="primaryHeader" />
              <DateHeader />
            </TimelineHeaders>
            {/* <TimelineMarkers>
              <CursorMarker />
            </TimelineMarkers> */}
          </AnimatedTimeline>
        )}
      </Spring>
    </div>
  );
}
